import axios from 'axios'

import { Packages } from '../types'
import { getApiClient } from './apiClient'

export const fetchAuditData = async ({ service, side }: { service: string; side: string }): Promise<Packages> => {
  let responseList
  let responseAudit
  if (side === 'frontend') {
    const url = `${window.location.origin}/plus`
    responseList = await axios.get(`${url}/npmlist.json`)
    responseAudit = await axios.get(`${url}/npmaudit.json`)
  } else {
    responseList = await getApiClient(`${service}/`)
      .get('/npm-list')
      .catch(() => ({ data: null }))

    responseAudit = await getApiClient(`${service}/`)
      .get('/npm-audit')
      .catch(() => ({ data: null }))
  }

  return { npmList: responseList.data[0] ?? responseList.data, npmAudit: responseAudit.data }
}
